import {IContextMenuActions, IContextMenuActionsPointer} from "back/commons/actionables";
import {BarActions} from "back/commons/widgets/bars";
import {IS_Popupable, ORelativePosition} from "back/commons/widgets/popupable";
import {POPUP} from "back/commons/widgets/popups";
import {IWedFocusBarPointer} from "back/edit/wed/features/commonBar";
import {IWedEditor, IWedMgrPointer, WedMgr} from "back/edit/wed/wedEditor";
import {OWedEditorBoxConfig} from "back/edit/wed/wedEditorBox";
import {
	EWedletEditMode,
	findElementWedlet,
	IChildWedlet,
	IElementWedlet,
	IParentWedlet,
	IS_EltWedlet,
	isDisplayedWedlet,
	isEditableWedlet,
	isParentWedlet,
	ITargetableWedlet,
	IVirtualisableWedlet,
	IWedlet,
	IWedletActionCtx,
	OFindWedletOptions,
	WEDLET,
	WedletActionCtx
} from "back/edit/wed/wedlets/wedlet";
import {isWedletSingleElt, IWedletSingleElt} from "back/edit/wed/wedlets/wedletSingleElt";
import {AccelKeyMgr, ACTION, Action, ActionMenu, ActionSeparator, ActionWrapperFromSvc, IAction} from "lib/commons/actions";
import {IDomLogical, REG} from 'lib/commons/registry';
import {DOM, ENodeType, JSX} from "lib/commons/xml/dom";
import {DOMSH} from "lib/commons/xml/domsh";
import {IJmlObj, IJmlSet, JML} from "lib/commons/xml/jml";
import {IXAddr, IXAddrRange, IXAddrRangeSel, XA} from "lib/commons/xml/xAddr";
import {IDocBatch} from "lib/edit/docHolder";
import {Msg} from "lib/edit/ot/urban";
import {isXmlMsg, XmlBatch, XmlInsertMsg, XmlRangeState} from "lib/edit/ot/xmlHouse";
import {EPastePos} from "lib/edit/schema/schema";
import {EFuzzyType, ISkStructDef} from "lib/edit/schema/schemaAnnots";
import {ISkImporter, OSkImportDatas, OSkPasteContext} from "lib/edit/schema/schemaMeta";
import {JLastDatas} from "lib/commons/lastDatas";
import {SkRuleElt} from "lib/edit/schema/schemaPatterns";
import {CONVERT} from "lib/edit/import/convert";
import {IBoxElement} from "back/edit/wed/wedlets/box/boxTags";
import {GFX} from "lib/commons/utils/gfx";
import {BASIS} from "back/commons/basis";
import {LANG} from "lib/commons/lang";
import {HistoEditPoint} from "lib/edit/histoEditPoints";


//######### Couche Editor #########


export interface IWedEditorBoxSel extends IWedEditor {
	boxSelMgr?: BoxSelMgr;
}

export interface JLDScComments extends JLastDatas {
	scCmtsPd?: JLDScCommentPending[]
}

export interface JLDScCommentPending extends JLastDatas {
	/** Addr du thread de commentaire.*/
	xa: IXAddr
	/** Contenu du comment sauvé. */
	txt: string
	/** Offset du commentaire édité (si existe), -1 si dernier comment d'un thread existant. */
	offs?: number
	/** Date de dernière édition du commentaire (att updateTime || creationTime).*/
	dt?: string
}

/**
 * Agregation pour les IWedEditor.
 */
export function AgBoxSelEditor(cls: any): any {
	const proto = cls.prototype as IWedEditorBoxSel;
	const superInit = proto.initialize;
	proto.initialize = function (this: IWedEditorBoxSel, config: OWedEditorBoxConfig): IWedEditorBoxSel {
		superInit.call(this, config);
		this.boxSelMgr = new BoxSelMgr(this);
		if (!config.disableBoxSelection) {
			this.addEventListener("pointerdown", onPointerDown);
			this.boxSelMgr.accelKeyMgr = new AccelKeyMgr<IWedEditorBoxSel>().initFromMapActions((config.reg || REG.findReg<any>(this)).getListAsMap<Action<IWedEditorBoxSel>>("wed:box:sel:accelkeys"));
			this.boxSelMgr.accelKeyMgr.addAccelKey("c", "accel,shift", copyXmlMenu);
			this.addEventListener("keydown", onKeyDown, false);
			this.wedMgr.listeners.on("getFocus", onFocus);
			this.wedMgr.listeners.on("looseFocus", onBlur);
			this.wedMgr.listeners.on("clipboard", onClipboardEvent);
			this.wedMgr.listeners.on("readOnlyChangeAfter", onReadOnlyChange);
		}
		this.wedMgr.listeners.on("initLastDatas", async function (wedMgr: WedMgr, lastDatas: JLDScComments) {
			if (!lastDatas.scCmtsPd) return;
			//cas rare : un comment était en cours d'édition
			import("back/edit/wed/wedlets/box/boxScComment.js").then((exports) => {
				if (!wedMgr.rootWedlet) return; //raceCond
				exports.initLastDatasScComments(wedMgr, lastDatas.scCmtsPd);
			});
		});
		this.wedMgr.listeners.on("hookMsgAfter", hookMsgAfter);
		this.wedMgr.listeners.on("hookMsgForNextSel", hookMsgForNextSel);
		this.wedMgr.listeners.on("getCurrentSel", getCurrentSel);
		return this;
	};
	return cls;
}

const copyXmlMenu = new Action<IWedEditorBoxSel>("copyXml")
	.setLabel("Copier en XML")
	.setExecute((ctx: IWedEditorBoxSel, ev) => {
		const rg = ctx.boxSelMgr.range;
		if (!rg.isCollapsed) ctx.wedMgr.writeRangeToClipboardAsXml(rg);
	});


//######### Couche Wedlet #########

/** Gestion de la selection 'Box' par les IWedlet.*/
export interface IWedletBoxSelection extends IWedlet, ITargetableWedlet {
	focusWedlet(): void

	drawBoxSelection(inSel: boolean): void

	drawBoxSelActions(show: boolean, focusActionWidgets: HTMLElement[], what?: 'after'): void
}

export function isWedletBoxSelection(w: IWedlet): w is IWedletBoxSelection {return w && ("drawBoxSelection" in w)}


/**
 * Agregation pour les wedlets qui implémentent IWedletSingleElt.
 */
export function AgWedletBoxSelectionSingleElt(cls: any): any {
	const proto = cls.prototype as IWedletBoxSelection & IWedletSingleElt;
	proto.focusWedlet = focusWedlet;
	proto.drawBoxSelection = wedlet_drawBoxSelection;
	proto.drawBoxSelActions = wedlet_drawBoxSelActions;
	proto.highlightFromLink = highlightFromLink;
	return cls;
}


//######### Couche Element #########

/** Gestion de la selection 'Box' par les custom elements.*/
export interface IEltBoxSelection extends IBoxElement, IContextMenuActionsPointer<IWedMgrPointer>, IWedFocusBarPointer {

	/**
	 * box : container d'autres box
	 * caret : input de type text avec caret
	 * input : box terminal de type field sans caret (date, nombre, enum, radio, check, ptritem...)
	 */
	selMode?: 'box' | 'input' | 'caret'

	drawEltBoxSelection?(inSel: boolean): void

	drawEltBoxSelActions?(show: boolean, focusActionWidgets: HTMLElement[], what?: 'after'): void

	/** permet au widget de spécifier un sous-element détenteur du focus principal. */
	focusableElement?: HTMLElement

	/**
	 * Listes des actions pour le menu contextuel et la focusBar.
	 * Toute Action<IWedMgrPointer> peut être acceptée
	 * L'implémentation par défaut diffuse le IWedlet en contexte : Action<IWedlet>.
	 */
	actionsLists?: string[]

	/** Key de la Pref pour ordonner les ations. */
	groupOrderPref?: string

	/** OU groupOrder explicite */
	groupOrder?: string

	/**
	 * [Optionnel] Personnalisation de l'actionContext pour le menu contextuel et la focusBar.
	 * Par défaut, c'est le IWedlet de l'élément.
	 */
	actionContext?: IWedletActionCtx

	/**
	 * Propriétés pour le menu contextuel
	 */
	ctxMenuActions?: IContextMenuActions<IWedMgrPointer> | null

	/** Implémentation de la focusBar*/
	focusBar?: BarActions<IWedletActionCtx> | null;
	/** Interne, cache du focusBar construit mutualisé par modèle. */
	_focusBar?: BarActions<IWedletActionCtx> | null;

	/** Surcharge des fonctions du clipboard si cet élément détient le focus. */
	onClipboard?(ev: ClipboardEvent): boolean

	/** Permet à un élément de type input de récupérer l'évènement capté par son container qui va lui transmettre. */
	handleEventFromContainer?(ev: KeyboardEvent | MouseEvent): void
}

export function isEltBoxSelection(elt: any): elt is IEltBoxSelection {return elt instanceof Element && ("drawEltBoxSelection" in elt)}

interface OBoxSelectionOptions {
	/**
	 * box : container d'autres box
	 * caret : input de type text avec caret
	 * input : box terminal de type field sans caret (date, nombre, enum, radio, check, ptritem...)
	 */
	selMode?: 'box' | 'input' | 'caret'

	/**
	 * Permet de désactiver le caractère focusable du container lui-même,
	 * tout en gérant les boutons d'insertion/remplacement lorsque le focus est dans
	 * sa descendance : cf box-ctn-input.
	 * Valeur par défaut : 0 (focusable).
	 */
	tabIndex?: 0 | -1

	/** Listes des actions pour le menu contextuel et la focusBar. */
	actionsLists?: string[]

	/** Ordonnancement des actions : via liste ou explicite */
	groupOrderPref?: string

	groupOrder?: string

	force_ctxMenuActions?: boolean
	force_focusBar?: boolean
}

/**
 * Agregation pour les IElementWedlet qui implémentent IEltBoxSelection.
 */
export function AgEltBoxSelection(cls: any, options: OBoxSelectionOptions): any {
	const proto = cls.prototype as IEltBoxSelection;
	if (options.selMode) proto.selMode = options.selMode;
	const connectedCallback = proto.connectedCallback;
	proto.connectedCallback = function (this: IEltBoxSelection) {
		if (connectedCallback) connectedCallback.call(this);
		if (!this.wedlet.wedMgr.config.noFocus) (this.focusableElement || this).tabIndex = options.tabIndex || 0; //On rend la Box focusable
	};
	proto.drawEltBoxSelection = drawEltBoxSelection;
	proto.drawEltBoxSelActions = drawEltBoxSelActions;
	if (options.actionsLists) proto.actionsLists = options.actionsLists;
	if (options.groupOrderPref) proto.groupOrderPref = options.groupOrderPref;
	if (options.groupOrder) proto.groupOrder = options.groupOrder;
	if (options.force_ctxMenuActions || !('ctxMenuActions' in proto)) Object.defineProperty(proto, "ctxMenuActions", {
		get: ctxMenuActions
	});
	if (options.force_focusBar || !('focusBar' in proto)) Object.defineProperty(proto, "focusBar", {
		get: focusBar
	});
	return cls;
}


//######### interne Wedlets #########

function focusWedlet(this: IWedletSingleElt & IWedletBoxSelection): HTMLElement {
	const elt = getFocusable(this);
	if (elt) {
		WEDLET.ensureContainersUncollapsed(elt);
		elt.focus();
	}
	return elt;
}

async function highlightFromLink(this: IWedletSingleElt, blockPos: 'nearest' | 'start') {
	const elt = getFocusable(this) || this.element;
	//On force le decollapse d'abord: nécessaire si contenu passé en display:none ou visibility:hidden car focus() non opértaionnel.
	WEDLET.ensureContainersUncollapsed(elt);
	elt.focus({preventScroll: true});
	BASIS.ensureVisible(elt, this.wedMgr.wedEditor.scrollContainer, blockPos);
}

function getFocusable(from: IWedletSingleElt): HTMLElement {
	let elt = (from.element as IEltBoxSelection).focusableElement;
	if (!elt) {
		elt = from.element;
		if (!DOM.IS_focusable(elt)) {
			elt = DOMSH.findFlatNext(elt, elt, DOM.IS_focusable) || DOMSH.findFlatParentElt(elt, from.wedMgr.wedEditor.rootNode, DOM.IS_focusable);
		}
	}
	return elt;
}

function wedlet_drawBoxSelection(this: IWedletSingleElt, inSel: boolean) {
	if (isEltBoxSelection(this.element)) {
		this.element.drawEltBoxSelection(inSel);
	} else {
		const parent = this.elementHost;
		if (parent) for (let ch = parent.firstElementChild; ch; ch = ch.nextElementSibling) {
			if (IS_EltWedlet(ch) && isWedletBoxSelection(ch.wedlet)) {
				ch.wedlet.drawBoxSelection(inSel);
			}
		}
	}
}

function wedlet_drawBoxSelActions(this: IWedletBoxSelection & IWedletSingleElt, show: boolean, focusActionWidgets: HTMLElement[], what?: 'after') {
	if (isEltBoxSelection(this.element)) {
		this.element.drawEltBoxSelActions(show, focusActionWidgets, what);
	} else if (isWedletBoxSelection(this.wedParent)) {
		this.wedParent.drawBoxSelActions(show, focusActionWidgets, 'after');
		// let parent = this.element.delegatedHost || this.element;
		// for (let ch = parent.firstElementChild; ch; ch = ch.nextElementSibling) {
		// 	if (IS_EltWedlet(ch) && isWedletBoxSelection(ch.wedlet)) {
		// 		ch.wedlet.drawBoxSelActions(show);
		// 	}
		// }
	}
}


//######### BoxSelMgr #########

export class BoxSelMgr {

	/** Navigation clavier. */
	accelKeyMgr: AccelKeyMgr<IWedEditorBoxSel>;

	/** Sel courante. */
	range: XmlRangeState = new XmlRangeState().init("sel", null, [], []);

	htmlSel: Selection = window.getSelection();

	activeWedlet: IWedletBoxSelection | null;

	selInVirtual: boolean;

	/**
	 * Ancre de départ de la sélection multiple (start ou end du range).
	 * null si la sel actuelle n'est pas multiple.
	 */
	protected multiSelBaseIsStart: boolean | null = null;

	/** Widgets actifs liés au focus en cours (à supprimer sur la perte du focus) */
	focusActionWidgets?: HTMLElement[] = [];


	constructor(public editor: IWedEditorBoxSel) {
	}

	isSingleSel() {return this.activeWedlet && this.multiSelBaseIsStart === null}

	clearSel() {
		if (!this.activeWedlet) return;
		this.xUnactiveWedlet();
		this._drawSelMulti(this.range, false);
		const empty = [] as IXAddr;
		this.range.setRange(empty, empty);
	}

	_selHidden = false;

	hideSel() {
		this._selHidden = true;
		if (this.activeWedlet) this._drawSelSingle(this.activeWedlet, false);
		this._drawSelMulti(this.range, false);
	}

	showSel() {
		this._selHidden = false;
		if (this.activeWedlet) this._drawSelSingle(this.activeWedlet, true);
		this._drawSelMulti(this.range, true);
	}

	selectWedlet(wedletToSel: IWedletBoxSelection) {
		if (this.activeWedlet === wedletToSel && !this._selHidden) return;
		if (!wedletToSel.wedParent) return; //pas de wedlet parent, pas sélectionnable (diff foreign)
		if (this._selHidden) {
			this._selHidden = false;
		} else {
			this.xUnactiveWedlet();
			this._drawSelMulti(this.range, false);
		}
		this.activeWedlet = wedletToSel;
		const anchor = wedletToSel.wedAnchor;
		if (wedletToSel.isVirtual()) {
			this.selInVirtual = true;
			this.range.setRange(anchor, anchor);
		} else {
			this.selInVirtual = false;
			if (XA.isAttribute(anchor)) {
				this.range.setRange(anchor, anchor);
			} else {
				this.range.setRange(anchor, XA.newBd(anchor).incrAtDepth(-1, 1).xa);
			}
		}
		this._drawSelSingle(wedletToSel, true);
	}

	extendSelTo(wedletToSel: IWedletBoxSelection) {
		if (this._selHidden) this.showSel();
		let extent = wedletToSel.wedAnchor;
		const multiSelBaseWasStart = this.multiSelBaseIsStart;
		let base = multiSelBaseWasStart === false ? this.range.end : this.range.start;
		if (!base) {
			this.selectWedlet(wedletToSel);
		} else {
			this.xUnactiveWedlet();
			this._drawSelMulti(this.range, false);
			this.selInVirtual = false;
			if (XA.isAttribute(base)) base = XA.up(base);
			if (XA.isAttribute(extent)) {
				extent = XA.up(extent);
				const wedletElt = wedletToSel.wedParent;
				if (!isWedletBoxSelection(wedletElt)) {
					this.selectWedlet(wedletToSel);
					return;
				}
				wedletToSel = wedletElt;
			}
			this.activeWedlet = wedletToSel; //courtcircuite BoxSelMgr.selectWedlet();
			wedletToSel.focusWedlet();
			if (XA.isAnc(extent, base) || XA.isBefore(extent, base)) {
				//extent avant base
				if (multiSelBaseWasStart !== false) base = XA.incrAtDepth(base, -1, 1); //on passe de l'autre coté de la base
				this.multiSelBaseIsStart = false;
				this.range.setRange(extent, base);
			} else {
				//base avant extent
				if (multiSelBaseWasStart === false) base = XA.incrAtDepth(base, -1, -1); //on passe de l'autre coté de la base
				extent = XA.incrAtDepth(extent, -1, 1);
				this.multiSelBaseIsStart = true;
				this.range.setRange(base, extent);
			}
			this._drawSelMulti(this.range, true);
		}
	}

	/** ATTENTION rg.end est inclus dans la sélection. */
	setSelection(rg: IXAddrRange): boolean {
		if (!rg.end || XA.isEquals(rg.start, rg.end)) {
			//Si sel collapsed, on passe par focusAroundXAddr pour ne pas changer la sel si ce wedlet a déjà le focus :
			// sinon on tue l'event 'input' et l'ins du 1er caractère dans un context virtuel d'un txt (pb beforeInput not cancelable).
			return this.focusAroundXAddr(rg.start);
		}
		let start = WEDLET.findWedlet(this.editor.wedMgr.rootWedlet, rg.start, WEDLET.FINDOPTIONS_lastAncestorIfNone);
		while (!isWedletBoxSelection(start)) {
			if (start == null) return false;
			start = start.wedParent;
		}
		let end = WEDLET.findWedlet(this.editor.wedMgr.rootWedlet, rg.end, WEDLET.FINDOPTIONS_lastAncestorIfNone);
		while (end && !isWedletBoxSelection(end)) end = end.wedParent;
		if (!end || start === end) {
			//pour ne pas perdre une sel interne dans ce widget.
			return this.focusAroundXAddr(rg.start);
		} else {
			this.selectWedlet(start);
			if (end) this.extendSelTo(end as IWedletBoxSelection);
			return true;
		}
	}

	/** Force la construction des offscreen en synchrone MAIS ne gère pas le cas des chargements asynchrones (XXX ajouter méth async ?). */
	findAroundXAddr(xa: IXAddr): IWedletBoxSelection {
		const find = {lastAncestorIfNone: true, wedletNotFoundDepth: -1, forceFetch: true, mainBranch: true} as OFindWedletOptions;
		let wedlet = WEDLET.findWedlet(this.editor.wedMgr.rootWedlet, xa, find);
		if (wedlet && find.wedletNotFoundDepth > 0 && isParentWedlet(wedlet)) {
			const notFound = xa[find.wedletNotFoundDepth];
			if (typeof notFound === 'number') {
				const prev = wedlet.findWedletChild(notFound - 1, {mainBranch: true, forceFetch: true}) as IWedlet;
				if (prev) wedlet = prev;
			}
		}
		while (!isWedletBoxSelection(wedlet)) {
			if (wedlet == null) return null;
			wedlet = wedlet.wedParent;
		}
		return wedlet;
	}

	focusAroundXAddr(xa: IXAddr): boolean {
		const wedlet = this.findAroundXAddr(xa);
		//On vérifie que le focus actuel ne soit pas déjà dans notre cible (cas des virtual wedlets qui se concrétisent ou des box-inputs).
		if (isWedletSingleElt(wedlet)) {
			const elt = wedlet.element as HTMLElement;
			if (elt.matches(":focus-within")) {
				//On s'assure d'etre dans le viewPort.
				const focused = DOMSH.findDeepActiveElement(DOMSH.findDocumentOrShadowRoot(elt));
				//console.log("focused:::::", focused);
				if (focused) BASIS.ensureVisible(focused as HTMLElement, this.editor.scrollContainer, "nearest");
				return false;
			}
		}
		if (wedlet) {
			wedlet.focusWedlet();
			return true;
		}
		return false;
	}

	focusFirst(root: IParentWedlet) {
		function findFocusFirst(w: IChildWedlet): 'stop' | void {
			if (isWedletBoxSelection(w)) {
				w.focusWedlet();
				return "stop";
			}
			if (isParentWedlet(w)) (w as IParentWedlet).visitWedletChildren(-1, Infinity, findFocusFirst, WEDLET.VISITOPTIONS_mainBranch);
		}

		root.visitWedletChildren(-1, Infinity, findFocusFirst, WEDLET.VISITOPTIONS_mainBranch);
	}

	/** Suite à chgt state readOnly ou passage d'un contenu virtuel à réel... */
	redrawSelection() {
		if (this._selHidden) return;
		if (isWedletSingleElt(this.activeWedlet) && (!this.activeWedlet.element || !this.activeWedlet.element.isConnected)) {
			//this.activeWedlet perdu, on sort XXX envisager api IWeldet.isConnected ?
			this.clearSel();
			return;
		}
		if (this.isSingleSel()) {
			if (this.selInVirtual && !this.activeWedlet.isVirtual()) {
				//On est plus virtuel
				const wedlet = this.activeWedlet;
				this.clearSel();
				this.selectWedlet(wedlet);
			} else {
				this._drawSelSingle(this.activeWedlet, true);
			}
		}
	}

	/** Change la sélection SANS FOCUS. */
	markWedlet(wedletToSel: IWedletBoxSelection, ensureVisible: boolean = false) {
		if (!wedletToSel) return;
		this.xUnactiveWedlet();
		if (this._selHidden) {
			this._selHidden = false;
		} else {
			this._drawSelMulti(this.range, false);
		}
		const anchor = wedletToSel.wedAnchor;
		if (wedletToSel.isVirtual()) {
			this.selInVirtual = true;
			this.range.setRange(anchor, anchor);
		} else {
			this.selInVirtual = false;
			if (XA.isAttribute(anchor)) {
				this.range.setRange(anchor, anchor);
			} else {
				this.range.setRange(anchor, XA.newBd(anchor).incrAtDepth(-1, 1).xa);
			}
		}
		if (ensureVisible && isWedletSingleElt(wedletToSel)) {
			BASIS.ensureVisible(wedletToSel.element, this.editor.scrollContainer, "nearest");
		}
		wedletToSel.drawBoxSelection(true);
	}

	/** Supprime le contenu de la sélection courante. */
	deleteContentSelection(batchIn?: IDocBatch) {
		this._drawSelMulti(this.range, false);
		const batch = batchIn || this.editor.wedMgr.docHolder.newBatch();
		if (XA.isAttribute(this.range.start)) {
			//sel unique d'un attribut
			const wedlet = WEDLET.findWedlet(this.editor.wedMgr.rootWedlet, this.range.start);
			if (wedlet) {
				if (isEditableWedlet(wedlet) && wedlet.editMode !== EWedletEditMode.write) return;
				const xa = wedlet.wedParent.onChildEmptied((subXa: IXAddr) => XA.isEquals(this.range.start, subXa));
				if (xa) batch.deleteSequence(xa, 1);
				else batch.setAttr(this.range.start, null);
			} //else batch.setAttr(this.range.start, null); pourquoi ? pb mode readonly non controlable.
		} else if (!this.range.isCollapsed) {
			let allowed = true;
			WEDLET.visitRange(this.editor.wedMgr.rootWedlet, this.range, w => {
				if (isEditableWedlet(w) && w.editMode !== EWedletEditMode.write) {
					allowed = false;
					return 'stop';
				}
			}, WEDLET.VISITOPTIONS_mainBranch);
			if (!allowed) return;
			batch.deleteRange(WEDLET.absorbContainersOnDelete(this.editor.wedMgr.rootWedlet, this.range));
		}
		if (!batchIn) batch.doBatch();
	}

	visitSelectedWedlets<T>(cb: (w: IWedlet) => T): T | undefined {
		if (XA.isAttribute(this.range.start)) {
			//Sel d'un seul attribut
			const attWedlet = WEDLET.findWedlet(this.editor.wedMgr.rootWedlet, this.range.start);
			if (isWedletBoxSelection(attWedlet)) return cb(attWedlet);
		} else {
			//Sel d'un range
			let r: T;
			WEDLET.visitRange(this.editor.wedMgr.rootWedlet, this.range, w => {
				if (isWedletBoxSelection(w)) {
					r = cb(w);
					if (r !== undefined) return 'stop';
				}
			}, WEDLET.VISITOPTIONS_mainBranch);
			return r;
		}

	}

	protected _drawSelSingle(wedletToSel: IWedletBoxSelection, show: boolean) {
		this.focusActionWidgets.forEach(elt => {try {elt.remove()} catch {}});
		this.focusActionWidgets.length = 0;
		wedletToSel.drawBoxSelection(show);
		wedletToSel.drawBoxSelActions(show, this.focusActionWidgets);
	}

	protected _drawSelMulti(range: IXAddrRange, select: boolean) {
		if (!select) this.multiSelBaseIsStart = null;
		if (XA.isAttribute(range.start)) {
			//Sel d'un seul attribut
			const attWedlet = WEDLET.findWedlet(this.editor.wedMgr.rootWedlet, range.start);
			if (isWedletBoxSelection(attWedlet)) attWedlet.drawBoxSelection(select);
		} else {
			//Sel d'un range
			WEDLET.visitRange(this.editor.wedMgr.rootWedlet, range, w => {
				if (isWedletBoxSelection(w)) w.drawBoxSelection(select);
			}, WEDLET.VISITOPTIONS_mainBranch);
		}
	}

	protected xUnactiveWedlet() {
		if (this.activeWedlet) {
			if (!this._selHidden) this._drawSelSingle(this.activeWedlet, false);
			this.activeWedlet = null;
			this.selInVirtual = false;
		}
	}

	toString() {
		return this.range.toString();
	}

}

//######### Default Actions #########

REG.reg.registerSvc('wedBoxSelDelete', 1, new Action<IWedEditorBoxSel | IWedletActionCtx>('wedBoxSelDelete')
	.setLabel("Supprimer la sélection")
	.setIcon("/@skin@/edit/wed/deleteTag.svg")
	.setVisible((ctx: IWedEditorBoxSel | IWedletActionCtx) => {
		const wedMgr = ctx.wedMgr;
		const boxSelMgr = (wedMgr.wedEditor as IWedEditorBoxSel).boxSelMgr;
		return boxSelMgr && !boxSelMgr.selInVirtual && !(wedMgr.wedEditor.config as OWedEditorBoxConfig).disableBoxSelection;
	})
	.setEnabled((ctx: IWedEditorBoxSel | IWedletActionCtx) => !ctx.wedMgr.readOnly)
	.setExecute(function (this: Action<IWedEditorBoxSel | IWedletActionCtx>, ctx: IWedEditorBoxSel | IWedletActionCtx, ev: Event) {
		const boxSelMgr = (ctx.wedMgr.wedEditor as IWedEditorBoxSel).boxSelMgr;
		if (boxSelMgr) boxSelMgr.deleteContentSelection();
	}));


REG.reg.registerSvc('wedBoxSelExclude', 1, new Action<IWedEditorBoxSel | IWedletActionCtx>('wedBoxSelExclude')
	.setLabel("Exclure la sélection")
	.setIcon("/@skin@/edit/wed/box/excludeTag.svg")
	.setVisible((ctx: IWedEditorBoxSel | IWedletActionCtx) => {
		const wedMgr = ctx.wedMgr;
		const boxSelMgr = (wedMgr.wedEditor as IWedEditorBoxSel).boxSelMgr;
		return (boxSelMgr && !boxSelMgr.selInVirtual && !(wedMgr.wedEditor.config as OWedEditorBoxConfig).disableBoxSelection && !boxSelMgr.range.isCollapsed && XA.isInSameSeq(boxSelMgr.range.start, boxSelMgr.range.end));
	})
	.setEnabled((ctx) => {
		//setVisible() a déjà vérifié une sélection valide (sameSeq en particulier),
		//boxSelMgr.activeWedlet est donc nécessairement un des wedlets sélectionnés, on peut remonter au père pour valider la permission en écriture.
		return WEDLET.resolveEditMode((ctx.wedMgr.wedEditor as IWedEditorBoxSel).boxSelMgr.activeWedlet.wedParent) === EWedletEditMode.write;
	})
	.setExecute(function (this: Action<IWedEditorBoxSel | IWedletActionCtx>, ctx: IWedEditorBoxSel | IWedletActionCtx, ev: Event) {
		const wedMgr = ctx.wedMgr;
		const rg = (wedMgr.wedEditor as IWedEditorBoxSel).boxSelMgr.range;
		if (!rg.isCollapsed && XA.isInSameSeq(rg.start, rg.end)) {
			const txt = wedMgr.docHolder.exportRange(rg, 'application/xml', {rootTagNs: "scenari.eu:exclude:1.0", rootTagName: "sexc:exclude"});
			const batch = wedMgr.docHolder.newBatch(rg);
			batch.deleteSequence(rg.start, XA.last(rg.end) as number - (XA.last(rg.start) as number));
			batch.insertJml(rg.start, [{'': JML.COMMENT, '=': DOM.escapeComment(txt)}]);
			batch.doBatch();
		}
	}));

//XXX à réactiver quand https://www.w3.org/TR/clipboard-apis/#async-clipboard-api généralisé.
// reg.registerSvc('wedBoxSelCopy', 1, new Action<IWedEditorBoxSel>('wedBoxSelCopy').setExecute(function (this: Action<IWedEditorBoxSel>, ctx: IWedEditorBoxSel, ev: Event) {
// 	let from = ev.composedPath()[0];
// 	if (IS_EltWedlet(from) && isWedletBoxSelection(from.wedlet)) {
// 		...
// 		ev.stopImmediatePropagation();
// 		ev.preventDefault();
// 	}
// }));
//
// reg.registerSvc('wedBoxSelCut', 1, new Action<IWedEditorBoxSel>('wedBoxSelCut').setExecute(function (this: Action<IWedEditorBoxSel>, ctx: IWedEditorBoxSel, ev: Event) {
// 	let from = ev.composedPath()[0];
// 	if (IS_EltWedlet(from) && isWedletBoxSelection(from.wedlet)) {
// 		...
// 		ev.stopImmediatePropagation();
// 		ev.preventDefault();
// 	}
// }));
//
// reg.registerSvc('wedBoxSelPaste', 1, new Action<IWedEditorBoxSel>('wedBoxSelPaste').setExecute(function (this: Action<IWedEditorBoxSel>, ctx: IWedEditorBoxSel, ev: Event) {
// 	let from = ev.composedPath()[0];
// 	if (IS_EltWedlet(from) && isWedletBoxSelection(from.wedlet)) {
// 		...
// 		ev.stopImmediatePropagation();
// 		ev.preventDefault();
// 	}
// }));

//######### Default AccelKeys #########

const delFromKeyboard = new ActionWrapperFromSvc('deleteBox')
	.setWrappedSvcCd('wedBoxSelDelete')
	.setExecute(function (this: ActionWrapperFromSvc<IWedEditorBoxSel>, ctx: IWedEditorBoxSel, ev: Event) {
		const from = ev.composedPath()[0];
		if (IS_EltWedlet(from) && isWedletBoxSelection(from.wedlet)) {
			this.getWrapped(ctx).execute(ctx, ev);
		} else return 'noPreventDefault';
	});

REG.reg.addToList("wed:box:sel:accelkeys", 'Delete', 1, delFromKeyboard);
REG.reg.addToList("wed:box:sel:accelkeys", 'Backspace', 1, delFromKeyboard);

//XXX à réactiver quand https://www.w3.org/TR/clipboard-apis/#async-clipboard-api généralisé.
// reg.addSvcToList("wed:box:sel:accelkeys", 'C-accel', 1, 'wedBoxSelCopy');
// reg.addSvcToList("wed:box:sel:accelkeys", 'X-accel', 1, 'wedBoxSelCut');
// reg.addSvcToList("wed:box:sel:accelkeys", 'V-accel', 1, 'wedBoxSelPaste');

REG.reg.addToList("wed:box:sel:accelkeys", 'Escape', 1, new Action<IWedEditorBoxSel>("boxEscape").setExecute(function (this: Action<IWedEditorBoxSel>, ctx: IWedEditorBoxSel, ev: Event) {
	const from = ev.composedPath().find((node: IEltBoxSelection, i: number) => node.selMode === 'box' && i > 0) as IElementWedlet;
	if (from) {
		(from.wedlet as IWedletBoxSelection).focusWedlet();
	} else return 'noStopPropag-noPreventDefault';
}));

REG.reg.addToList("wed:box:sel:accelkeys", 'ArrowUp', 1, new Action<IWedEditorBoxSel>("boxArrowUp").setExecute(function (this: Action<IWedEditorBoxSel>, ctx: IWedEditorBoxSel, ev: Event) {
	const from = ev.composedPath()[0];
	if (isEltBoxSelection(from)) {
		if (from instanceof HTMLElement) {
			const scrollCtn = ctx.scrollContainer;
			if (scrollCtn) {
				const scrollRect = scrollCtn.getBoundingClientRect();
				const rect = (from as HTMLElement).getBoundingClientRect();
				if (rect.top < scrollRect.top) {
					scrollCtn.scrollBy(0, -Math.min(scrollRect.height * .8, scrollRect.top - rect.top + scrollRect.height * .1));
					return;
				}
			}
		}
		const prev = DOMSH.findFlatPrevUncle(from, ctx.rootNode, isBox);
		if (prev) {
			((prev as IEltBoxSelection).wedlet as IWedletBoxSelection).focusWedlet();
			ev.preventDefault();
		} else if (ctx.config.crossNav) return 'noStopPropag-noPreventDefault';
	} else return 'noPreventDefault';
}));

REG.reg.addToList("wed:box:sel:accelkeys", 'ArrowDown', 1, new Action<IWedEditorBoxSel>("ArrowDown").setExecute(function (this: Action<IWedEditorBoxSel>, ctx: IWedEditorBoxSel, ev: Event) {
	const from = ev.composedPath()[0];
	if (isEltBoxSelection(from)) {
		if (from instanceof HTMLElement) {
			const scrollCtn = ctx.scrollContainer;
			if (scrollCtn) {
				const scrollRect = scrollCtn.getBoundingClientRect();
				const rect = (from as HTMLElement).getBoundingClientRect();
				if (rect.bottom > scrollRect.bottom) {
					scrollCtn.scrollBy(0, Math.min(scrollRect.height * .8, rect.bottom - scrollRect.bottom + scrollRect.height * .1));
					return;
				}
			}
		}
		const next = DOMSH.findFlatNextUncle(from, ctx.rootNode, isBox);
		if (next) {
			((next as IEltBoxSelection).wedlet as IWedletBoxSelection).focusWedlet();
			ev.preventDefault();
		} else if (ctx.config.crossNav) return 'noStopPropag-noPreventDefault';
	} else return 'noPreventDefault';
}));


REG.reg.addToList("wed:box:sel:accelkeys", 'ArrowLeft', 1, new Action<IWedEditorBoxSel>("ArrowLeft").setExecute(function (this: Action<IWedEditorBoxSel>, ctx: IWedEditorBoxSel, ev: Event) {
	const from = ev.composedPath()[0];
	if (isEltBoxSelection(from)) {
		const prev = DOMSH.findFlatPrevious(from, ctx.rootNode, isBox);
		if (prev) {
			((prev as IEltBoxSelection).wedlet as IWedletBoxSelection).focusWedlet();
			ev.preventDefault();
		} else if (ctx.config.crossNav) return 'noStopPropag-noPreventDefault';
	} else return 'noPreventDefault';
}));

REG.reg.addToList("wed:box:sel:accelkeys", 'ArrowRight', 1, new Action<IWedEditorBoxSel>("ArrowRight").setExecute(function (this: Action<IWedEditorBoxSel>, ctx: IWedEditorBoxSel, ev: Event) {
	const from = ev.composedPath()[0];
	if (isEltBoxSelection(from)) {
		const next = DOMSH.findFlatNext(from, ctx.rootNode, isBox);
		if (next) {
			(next.wedlet as IWedletBoxSelection).focusWedlet();
			ev.preventDefault();
		} else if (ctx.config.crossNav) return 'noStopPropag-noPreventDefault';
	} else return 'noPreventDefault';
}));

function isBox(n: Node): n is IEltBoxSelection {return isEltBoxSelection(n) && n.selMode === 'box' && getComputedStyle(n).display !== 'none'}

//######### interne IEltBoxSelection #########

function drawEltBoxSelection(this: IEltBoxSelection, inSel: boolean) {
	if (this.selMode === 'box') {
		if (inSel) this.setAttribute("selected", "");
		else this.removeAttribute("selected");
	}
}

function drawEltBoxSelActions(this: IEltBoxSelection, show: boolean, focusActionWidgets: HTMLElement[], what?: 'after') {
	if (!show || !WEDLET.isWritableWedlet(this.wedlet.wedParent) || this.hasAttribute("hide-actions")) return;
	const descEditMode = (isEditableWedlet(this.wedlet) && "getEditModeForDesc" in this.wedlet) ? this.wedlet.getEditModeForDesc(null) : undefined;
	const insideEditable = (descEditMode ? descEditMode.editMode === EWedletEditMode.write || descEditMode.editMode === EWedletEditMode.na : true) && WEDLET.isWritableWedlet(this.wedlet);
	const addForVirtualNode = (wedlet: IVirtualisableWedlet, wedMgr: WedMgr, target: IElementWedlet): boolean => {
		if (!wedlet.wedParent || (this === target && wedlet.element.hasAttribute("replace-here"))) {
			//On exclu la recherche d'alternatives si on est dans un contexte d'un replace-in forcé (widget porté par le père).
			return false;
		}
		let structs: ISkStructDef[];
		if (wedlet.model.nodeType === ENodeType.attribute) {
			structs = wedMgr.docHolder.getAlternateStructs(wedlet.wedParent.wedAnchor, 0, ENodeType.attribute, wedlet.model.nodeName, WEDLET.buildVirtualPath(wedlet.wedParent) as Array<IJmlObj>);
		} else if (wedlet.wedParent.isVirtual()) {
			structs = wedMgr.docHolder.getAlternateStructs(wedlet.wedParent.wedAnchor, wedlet.getVirtualXaPart() as number, ENodeType.element, wedlet.model.nodeName, WEDLET.buildVirtualPath(wedlet.wedParent) as Array<IJmlObj>);
		} else {
			//context parent non virtuel, on cherche tout ce qui est insérable à ce point (donc aussi ce qui peut remplacer ce wedlet virtuel)
			const insertables = wedMgr.docHolder.getInsertableStructs(wedlet.wedParent.wedAnchor, wedlet.getVirtualXaPart() as number, null, this.getAttribute("replace-in") != null);
			if (insertables[1]) {
				insertables[1].push(...insertables[0]);
				structs = insertables[1];
			} else {
				structs = insertables[0];
			}
		}
		if (WEDLET.cleanupStructList(structs, WEDLET.findVirtualWedletsBefore(target, true), WEDLET.isTextBindBefore(target)) === 0) return false;
		if (WEDLET.cleanupStructList(structs, WEDLET.findVirtualWedletsAfter(target), WEDLET.isTextBindAfter(target)) === 0) return false;
		if (this !== target) {
			//Remplacement d'un fils skippped.
			insertReplaceBtnIn(wedMgr, this, this.getAttribute("replace-in"), wedlet, structs, focusActionWidgets);
		} else {
			focusActionWidgets.push(createInsertBtn(wedMgr, 'middle', structs, target, GFX.getContainerOrient(DOMSH.getParentElt(target))));
		}
		return true;
	};

	const wedlet = this.wedlet;
	const wedMgr = wedlet.wedMgr;
	if (wedlet.wedParent) {
		const xaPart = wedlet.xaPart;
		//on n'est pas à la racine
		let countBefore: number, countAfter: number;
		if (what !== 'after') {
			if (typeof xaPart === 'number' || typeof xaPart === 'string') {
				let structsBefore: ISkStructDef[], structsAfter: ISkStructDef[], structsReplace: ISkStructDef[];
				//On exclu la recherche d'alternatives si on est dans un contexte d'un replace-in forcé (widget porté par le père).
				const doAlterPart = isWedletSingleElt(wedlet) && wedlet.element.hasAttribute("replace-here") ? undefined : xaPart;
				if (typeof xaPart === 'number') {
					//On est ni attribut ni virtuel.
					[structsBefore, structsAfter, structsReplace] = wedMgr.docHolder.getInsertableStructs(wedlet.wedParent.wedAnchor, xaPart, xaPart + 1, false, doAlterPart);
					if (wedlet.model.nodeType == ENodeType.comment) {
						//Un commentaire n'est pas structurant, donc on élimine les virtuals et textes avant ET après.
						//console.log("wedlet.model.nodeType::::::", wedlet.model.nodeType);
						const virtuals = WEDLET.findVirtualWedletsAfter(this, WEDLET.findVirtualWedletsBefore(this));
						const isText = WEDLET.isTextBindBefore(this) || WEDLET.isTextBindAfter(this);
						countBefore = WEDLET.cleanupStructList(structsBefore, virtuals, isText);
						countAfter = WEDLET.cleanupStructList(structsAfter, virtuals, isText);
						structsReplace = null; //pas de remplacement possible.
					} else {
						countBefore = WEDLET.cleanupStructList(structsBefore, WEDLET.findVirtualWedletsBefore(this), WEDLET.isTextBindBefore(this));
						countAfter = WEDLET.cleanupStructList(structsAfter, WEDLET.findVirtualWedletsAfter(this), WEDLET.isTextBindAfter(this));
					}
					//console.log("getInsertableStructs:::", structsBefore, structsAfter, structsReplace);
				} else if (doAlterPart != null) {
					//On est un attribut non virtuel => remplacement possibles
					structsReplace = wedMgr.docHolder.getAlternateStructs(wedlet.wedParent.wedAnchor, 0, ENodeType.attribute, doAlterPart as string);
				}
				if (structsReplace && structsReplace.length === 0) structsReplace = null;
				if (countBefore > 0 || countAfter > 0 || structsReplace != null) {
					const ctnOrient = GFX.getContainerOrient(DOMSH.getParentElt(this));
					let forceSpace = 0;
					if (ctnOrient === "v" && structsReplace != null && countBefore > 0 && countAfter > 0) {
						//Pb de positionnement si 3 btns et haueur faible.
						const fontSize = parseInt(getComputedStyle(this).fontSize);
						const height = this.clientHeight;
						let missingSp = fontSize * 2.5 - height;
						if (missingSp > 0) forceSpace = missingSp / 2 / fontSize;
					}
					if (countBefore > 0) focusActionWidgets.push(createInsertBtn(wedMgr, 'before', structsBefore, this, ctnOrient, forceSpace));
					if (structsReplace != null) focusActionWidgets.push(createReplaceBtn(wedMgr, structsReplace, this, ctnOrient, countBefore > 0 ? .8 - forceSpace : 0));
					if (countAfter > 0) focusActionWidgets.push(createInsertBtn(wedMgr, 'after', structsAfter, this, ctnOrient, forceSpace));
				}
			} else if (wedlet.isVirtual()) {
				addForVirtualNode(wedlet, wedMgr, this);
			}
			if (insideEditable) {
				const insChildren = wedlet.model.config.getAttribute("insertUiForChildren");
				const insAtts = wedlet.model.config.getAttribute("insertUiForAtts");
				if ((insChildren || insAtts) && isWedletSingleElt(wedlet)) {
					//Demande de gestion de l'insertion de fils
					const subStructs = wedMgr.docHolder.getInsertableStructsAll(insChildren ? insAtts ? 'both' : 'children' : 'atts', wedlet.wedAnchor, WEDLET.buildVirtualPath(wedlet) as Array<IJmlObj>);
					if (insAtts) {
						const s = subStructs[insChildren ? 1 : 0];
						if (WEDLET.cleanupStructList(s, WEDLET.findAllChildrenVirtualWedlets(this)) > 0) { //on élimine les wedlets virtuels déjà affichés
							focusActionWidgets.push(createInsertChildBtn(wedMgr, s, wedlet.element, insAtts, "att"));
						}
					}
					if (insChildren && WEDLET.cleanupStructList(subStructs[0], WEDLET.findAllChildrenVirtualWedlets(this)) > 0) { //on élimine les wedlets virtuels déjà affichés
						focusActionWidgets.push(createInsertChildBtn(wedMgr, subStructs[0], wedlet.element, insChildren));
					}
				}
			}
		}
		if (!countAfter && wedlet.model.nodeType !== ENodeType.attribute) {
			//On va chercher un ancêtre après qui permettrait une insertion (pour faciliter la poursuite de l'écriture).
			const predicate = (elt: Element): elt is Element => {
				if (isEltBoxSelection(elt) && !elt.wedlet.isVirtual()) {
					const parent = elt.wedlet.wedParent;
					if (parent && parent.wedParent && WEDLET.isWritableWedlet(parent.wedParent) && isWedletSingleElt(parent) && !parent.element.hasAttribute("hide-actions")) {
						const [structsAfter] = wedMgr.docHolder.getInsertableStructs(parent.wedAnchor, elt.wedlet.xaPart as number + 1);
						countAfter = WEDLET.cleanupStructList(structsAfter, WEDLET.findVirtualWedletsAfter(elt), WEDLET.isTextBindAfter(elt));
						if (countAfter > 0) {
							focusActionWidgets.push(createInsertBtn(wedMgr, 'after', structsAfter, elt, GFX.getContainerOrient(DOMSH.getParentElt(elt))));
							return true;
						}
					}
				}
				return false;
			};
			if (what !== 'after') DOMSH.findFlatParentElt((wedlet as IWedletSingleElt).element, wedMgr.wedEditor.rootNode, predicate);
			else DOMSH.findFlatParentEltOrSelf((wedlet as IWedletSingleElt).element, wedMgr.wedEditor.rootNode, predicate);
		}

		const replIn = insideEditable ? (wedlet as IWedletSingleElt).element.getAttribute("replace-in") : null;
		if (replIn != null) {
			//Recherche des containers skipped fils pour activer le ReplaceBtn
			let elt = DOM.findLastChild((wedlet as IWedletSingleElt).elementHost, replaceInSelector1) || DOM.findLastChild((wedlet as IWedletSingleElt).elementHost, replaceInSelector2);
			while (elt) {
				const currWedlet = elt.wedlet;
				if (currWedlet.isVirtual()) {
					if (addForVirtualNode(currWedlet, wedMgr, elt)) break;
				} else if (currWedlet.wedParent) {
					let structsReplace: ISkStructDef[];
					if (currWedlet.model.nodeType === ENodeType.attribute) {
						structsReplace = wedMgr.docHolder.getAlternateStructs(currWedlet.wedParent.wedAnchor, 0, ENodeType.attribute, currWedlet.xaPart as string);
					} else {
						structsReplace = wedMgr.docHolder.getAlternateStructs(currWedlet.wedParent.wedAnchor, currWedlet.xaPart as number, currWedlet.model.nodeType as ENodeType, currWedlet.wedNodeName || currWedlet.model.nodeName);
					}
					if (structsReplace != null) {
						insertReplaceBtnIn(wedMgr, this, replIn, currWedlet, structsReplace, focusActionWidgets);
						break;
					}
				}
				//On s'enfonce dans la hiérarchie
				elt = DOM.findLastChild((currWedlet as IWedletSingleElt).elementHost, replaceInSelector1) || DOM.findLastChild((currWedlet as IWedletSingleElt).elementHost, replaceInSelector2);
			}
		}
	}
}

function replaceInSelector1(elt: any): elt is IElementWedlet {
	return elt.hasAttribute("replace-here") && IS_EltWedlet(elt);
}

function replaceInSelector2(elt: any): elt is IElementWedlet {
	return IS_EltWedlet(elt) && !isEltBoxSelection(elt);
}

interface IBoxBtns {
	structs?: ISkStructDef[]
	structPos?: 'before' | 'after' | 'replace' | 'child'
	/** Pour les remplacements dans les fils. */
	wedlet?: IWedlet
}

/** Bouton injectés autour du box sélectionné. */
function createInsertBtn(wedMgr: WedMgr, pos: 'before' | 'after' | 'middle', structs: ISkStructDef[], target: HTMLElement, ctnOrient: 'h' | 'v', forceSpace?: number): HTMLElement {
	const btn = document.createElement("box-btnadd") as HTMLElement & IBoxBtns;
	// BASIS.makeClickable(btn);
	// btn.setAttribute("role", "button");
	btn.setAttribute("pos", pos);
	const sr = btn.attachShadow(DOMSH.SHADOWDOM_INIT);
	wedMgr.reg.installSkin(btn.localName, sr);
	sr.appendChild(document.createTextNode(pos === 'middle' ? "+⇄" : "+"));
	btn.title = pos === 'before' ? "Insérer avant..." : (pos === 'after' ? "Insérer après..." : "Insérer autour ou remplacer...");
	btn.addEventListener("pointerdown", execBtnAdd);
	btn.structs = structs;
	btn.structPos = pos === 'middle' ? 'before' : pos;
	btn.style.position = "absolute";
	if (ctnOrient === 'v') {
		DOM.setStyleStart(btn, "-1em", target);
		switch (pos) {
		case 'after':
			btn.style.bottom = forceSpace ? `-${.8 + forceSpace}em` : "-.8em";
			break;
		case 'before':
			btn.style.top = forceSpace ? `-${.8 + forceSpace}em` : "-.8em";
			break;
		case 'middle':
			//btn.style.top = ".5em";
			break;
		}
	} else {
		btn.style.top = "-1em";
		switch (pos) {
		case 'after':
			DOM.setStyleEnd(btn, "-1em", target);
			break;
		case 'before':
			DOM.setStyleStart(btn, "-1em", target);
			break;
		case 'middle':
			DOM.setStyleStart(btn, "50%", target);
			break;
		}
	}
	const parent = target.shadowRoot || target;
	DOM.setStyle(target, "position", "relative");
	parent.insertBefore(btn, parent.firstChild); //pos === 'after' ? null :
	return btn;
}

function createInsertChildBtn(wedMgr: WedMgr, structs: ISkStructDef[], target: HTMLElement, parentSel: string, pos: 'child' | 'att' = "child"): HTMLElement {
	const btn = document.createElement("box-btnadd") as HTMLElement & IBoxBtns;
	btn.setAttribute("pos", pos);
	const sr = btn.attachShadow(DOMSH.SHADOWDOM_INIT);
	wedMgr.reg.installSkin(btn.localName, sr);
	sr.appendChild(document.createTextNode("+"));
	btn.structs = structs;
	btn.structPos = 'child';
	btn.title = pos === "child" ? "Insérer dedans..." : "Insérer un attribut...";
	btn.style.position = pos === "child" ? "absolute" : "relative";
	btn.addEventListener("pointerdown", execBtnAdd);
	DOM.setStyle(target, "position", "relative");
	((parentSel && target.shadowRoot?.querySelector(parentSel)) || target.shadowRoot || target).appendChild(btn);
	return btn;
}

/** Bouton inséré en fils lorsque que le fils est skipped mais peut être remplacé (ex/internalisation). */
function insertReplaceBtnIn(wedMgr: WedMgr, parentElt: IEltBoxSelection, insPath: string, wedlet: IWedlet, structs: ISkStructDef[], focusActionWidgets: HTMLElement[]) {
	DOM.setStyle(parentElt, "position", "relative");
	const btn = document.createElement("box-btnreplace-in") as HTMLElement & IBoxBtns;
	const sr = btn.attachShadow(DOMSH.SHADOWDOM_INIT);
	wedMgr.reg.installSkin("box-btnreplace", sr);
	sr.appendChild(document.createTextNode("⇄"));
	btn.title = "Remplacer...";
	btn.wedlet = wedlet;
	btn.addEventListener("pointerdown", wedlet.isVirtual() ? execBtnAdd : execBtnReplace);
	btn.structs = structs;
	btn.structPos = 'before';
	const p = parentElt.shadowRoot || parentElt;
	if (insPath === "") {
		p.appendChild(btn);
	} else if (insPath.startsWith("append:")) {
		const subP = p.querySelector(insPath.substring(7));
		subP.appendChild(btn);
	} else if (insPath.startsWith("insBefore:")) {
		const before = p.querySelector(insPath.substring(10));
		before.parentNode.insertBefore(btn, before);
	}
	focusActionWidgets.push(btn);
}

REG.reg.registerSkin('box-btnadd', 1, /* language=CSS */ `
	:host {
		border-radius: .2rem;
		background: var(--insbtn-bg);
		color: var(--insbtn-color);
		font-size: .8rem;
		cursor: pointer;
		width: .9rem;
		text-align: center;
		z-index: 700;
		user-select: none;
	}

	:host([pos=middle]) {
		line-height: 85%;
	}

	:host(:hover) {
		background: var(--insbtn-hover-bg);
	}
`);

function createReplaceBtn(wedMgr: WedMgr, structs: ISkStructDef[], target: HTMLElement, ctnOrient: 'h' | 'v', topPos: number): HTMLElement {
	const btn = document.createElement("box-btnreplace") as HTMLElement & IBoxBtns;
	// BASIS.makeClickable(btn);
	// btn.setAttribute("role", "button");
	const sr = btn.attachShadow(DOMSH.SHADOWDOM_INIT);
	wedMgr.reg.installSkin(btn.localName, sr);
	sr.appendChild(document.createTextNode("⇄"));
	btn.title = "Remplacer ou transformer...";
	btn.addEventListener("pointerdown", execBtnReplace);
	btn.structs = structs;
	btn.style.position = "absolute";
	if (ctnOrient === 'v') {
		DOM.setStyleStart(btn, "-1em", target);
		btn.style.top = `${topPos}em`;
	} else {
		DOM.setStyleStart(btn, "-1em", target);
	}
	DOM.setStyle(target, "position", "relative");
	const parent = target.shadowRoot || target;
	parent.insertBefore(btn, parent.firstChild);
	return btn
}

REG.reg.registerSkin('box-btnreplace', 1, /* language=CSS */ `
	:host {
		border-radius: .2rem;
		background: var(--insbtn-bg);
		color: var(--insbtn-color);
		font-size: .8rem;
		width: .9rem;
		text-align: center;
		cursor: pointer;
		user-select: none;
	}

	:host(:hover) {
		background: var(--insbtn-hover-bg);
	}
`);

export class InsertAction extends Action<IWedlet> {
	constructor(public struct: ISkStructDef, public wedlet: IWedlet, public pos: "before" | "after" | "replace" | "child") {
		super();
	}

	getLabel() {return this.struct.structLabel || this.struct.structName}

	execute(ctx: IWedlet, ev?: Event) {
		InsertAction.insertStruct(ctx.wedMgr, this.struct, this.wedlet, this.pos);
	}

	static async insertStruct(wedMgr: WedMgr, struct: ISkStructDef, wedlet: IWedlet, pos: "before" | "after" | "replace" | "child") {
		const batch: IDocBatch = wedMgr.docHolder.newBatch();
		let xa = wedlet.wedAnchor;
		let jml: IJmlSet;
		let atts: IJmlObj;
		if (pos === 'replace' && struct instanceof SkRuleElt && struct.convertFrom) {
			//On tente une conversion
			const src = {
				outStruct: struct,
				doc: wedMgr.docHolder.getDocument(),
				xa
			};
			const cnv = struct.convertFrom.findConverter(src);
			if (cnv) {
				const dst = await cnv.convert(src);
				if (dst) jml = CONVERT.getDstAsJml(dst);
			}
		}
		let finalName = struct.structName;
		if (!jml) {
			//Pas de conversion, construction du contenu par la struct
			jml = [];
			atts = Object.create(null);
			const partialName = pos === 'replace' && struct.createContentAsync ? await struct.createContentAsync(jml, atts, wedMgr.wedEditor.rootNode) : struct.createContent(jml, atts);
			if (partialName === false) return; //false => cancel by user
			if (typeof partialName === 'string') {
				//Insertion d'une struct générique
				//TODO écran de validation complet du name fusionné avec BoxNameInput pour passer l'input du name en dialogue flottant ?.
				finalName = await POPUP.prompt(
					<label>
						<div>{struct.structType === EFuzzyType.elements ? "Nom de cet élément" : "Nom de cet attribut"}</div>
						<input value={partialName} required pattern="^[A-Za-z_:][\w\-.:]*"/>
					</label>,
					wedMgr.wedEditor.rootNode, {titleBar: EFuzzyType.elements ? "Ajout d'un élément" : "Ajout d'un attribut"});
				if (!finalName) return;
				if (!struct.structMatch(struct.structType === EFuzzyType.elements ? ENodeType.element : ENodeType.attribute, finalName)) {
					POPUP.showNotifInfo("Ce nom n'est pas autorisé", wedMgr.wedEditor.rootNode);
					return;
				}
				if (struct.structType === EFuzzyType.elements) {
					jml.push({'': finalName || "x"})
				} else if (struct.structType === EFuzzyType.attributes) {
					let nm = finalName || "x";
					if (!wedlet.isVirtual()) {
						const elt = XA.findDomLast(xa, wedMgr.docHolder.getDocument()) as Element;
						while (elt.hasAttribute(nm)) nm += 'x';
					}
					atts[nm] = "";
				} else throw Error();
			}
		}
		if (isWedletSingleElt(wedlet) && !wedlet.element.isConnected) return; //détection d'une suppr concurrente

		//Liste finale des attributs à insérer
		let attNames = atts ? Object.keys(atts) : null;
		if (attNames?.length === 0) attNames = null;

		//Ajustement de xa d'insertion et élimination de la source en cas de "replace"
		if (pos === 'after') {
			XA.incrAtDepth(xa, -1, 1);
		} else if (pos === 'replace') {
			if (XA.isAttribute(xa)) {
				//On était sur un attribut
				batch.setAttr(xa, null);
				if (jml.length > 0) {
					//Cas du remplacement d'un attribut par un fils.
					//On pointait un attribut, on doit chercher l'offset d'insertion des noeuds fils.
					//*** Algo théorique, mais getInsertableOffset() prend en compte l'existance de l'attribut et rejette donc l'insertion du tag fils.
					// xa = XA.up(xa);
					// let firstNode = jml[0];
					// let offset = wedMgr.docHolder.getInsertableOffset(xa, struct.structType as ENodeType, "end", JML.isElt(firstNode) ? firstNode[''] : null);
					// if(offset<0) return;
					// xa = XA.append(xa, offset);
					//*** Algo simple : on ajoute en dernier fils.
					if (!wedlet.wedParent.isVirtual()) {
						const node = XA.findDomContainer(xa, wedMgr.docHolder.getDocument());
						xa = XA.setAtDepth(xa, -1, node.childNodes.length);
					} else {
						//contexte virtuel : on remplace l'attr par offset 0
						xa = XA.setAtDepth(xa, -1, 0);
					}
				} else {
					xa = XA.up(xa);
				}
			} else {
				//On était sur un noeud, on le suppr
				batch.deleteSequence(xa, 1);
				if (jml.length === 0 && attNames != null) xa = XA.up(xa); //le remplacement sont des atts sur le parent, on remonte
			}
		} else if (pos === 'child') {
			if (LANG.in(struct.structType, ENodeType.element, EFuzzyType.elements)) {
				//On cherche l'offset d'insertion du noeud fils
				const pos = wedlet.isVirtual() ? 0 : wedMgr.docHolder.getInsertableOffset(xa, ENodeType.element, 'end', finalName); //XXX si fuzzy ? passer struct en param ?
				if (pos < 0) return; //contenu possiblement modifié entre temmps
				XA.append(xa, pos);
			} else if (struct.structType == ENodeType.text) {
				const pos = wedlet.isVirtual() ? 0 : wedMgr.docHolder.getInsertableOffset(xa, ENodeType.text, 'end');
				if (pos < 0) return; //contenu possiblement modifié entre temmps
				XA.append(xa, pos);
			}
		}

		//Concrétisation du wedlet virtuel
		if (pos === 'child') {
			if (wedlet.isVirtual()) WEDLET.insertDatasFromDisplay(wedlet, batch);
		} else {
			if (wedlet.wedParent.isVirtual()) WEDLET.insertDatasFromDisplay(wedlet.wedParent, batch);
		}
		//Insertion du nouveau contenu
		if (attNames) {
			if (attNames.length > 1 || jml.length > 0) {
				//On insert plusieurs noeuds (atts ou children)
				const xaParent = XA.freeze(XA.up(xa));
				for (let i = 0; i < attNames.length; i++) {
					batch.setAttr(XA.append(xaParent, attNames[i]), atts[attNames[i]] || "");
				}
				if (jml.length > 0) {
					if (XA.isAttribute(xa)) xa = XA.setAtDepth(xa, -1, 0); // on pointait un attr en alternative avec des noeuds fils.
					batch.insertJml(xa, jml);
				}
			} else {
				//On insert un seul attribut
				xa = XA.append((pos === 'before' || XA.isAttribute(xa)) ? XA.up(xa) : xa, attNames[0]);
				batch.setAttr(xa, atts[attNames[0]] || "")
			}
		} else {
			//On insert que des noeuds fils
			if (XA.isAttribute(xa)) xa = XA.setAtDepth(xa, -1, 0); // on pointait un attr en alternative avec des noeuds fils.
			batch.insertJml(xa, jml);
		}
		batch.doBatch();
	}
}

class ReplaceAction extends InsertAction {
	execute(ctx: IWedlet, ev?: Event) {
		InsertAction.insertStruct(ctx.wedMgr, this.struct, this.wedlet, 'replace');
	}
}

function buildAddActions(wedlet: IWedlet, pos: "before" | "after" | "replace" | "child", structs: ISkStructDef[]): InsertAction[] {
	const actions = [];
	for (let i = 0; i < structs.length; i++) {
		const struct = structs[i];
		if (struct === null) continue;
		actions.push(new InsertAction(struct, wedlet, pos));
	}
	return actions;
}

function execBtnAdd(this: HTMLButtonElement & IBoxBtns, ev: Event) {
	const wedlet = this.wedlet || (findElementWedlet(this) as IEltBoxSelection).wedlet;
	const actions = buildAddActions(wedlet, this.structPos, this.structs);
	POPUP.showPopupActionsFromEvent({actions, actionContext: wedlet, restoreFocus: this}, ev);
	ev.stopImmediatePropagation();
	ev.preventDefault();
}

function buildReplaceActions(structs: ISkStructDef[], wedlet: IWedlet) {
	const actions = [];
	for (let i = 0; i < structs.length; i++) {
		const struct = structs[i];
		if (struct !== null) actions.push(new ReplaceAction(struct, wedlet, 'replace'));
	}
	return actions;
}

function execBtnReplace(this: HTMLButtonElement & IBoxBtns, ev: Event) {
	const wedlet = this.wedlet || (findElementWedlet(this) as IEltBoxSelection).wedlet;
	const actions = buildReplaceActions(this.structs, wedlet);
	POPUP.showPopupActionsFromEvent({actions, actionContext: wedlet, restoreFocus: this}, ev);
	ev.stopImmediatePropagation();
	ev.preventDefault();
}


//######### interne IWedEditorBoxSel #########

function hookMsgAfter(wedMgr: WedMgr, msg: Msg) {
	if (isXmlMsg(msg)) {
		//XmlInsertMsg, XmlDeleteMsg, XmlStrMsg
		const boxSelMgr = (wedMgr.wedEditor as IWedEditorBoxSel).boxSelMgr;
		if (!boxSelMgr.selInVirtual) boxSelMgr.range.update(msg);
	}
}

function hookMsgForNextSel(wedMgr: WedMgr, transac: Msg, msg: Msg): void | true {
	if (!msg || transac.getMeta('noFocus') === true) return;
	const boxSelMgr = (wedMgr.wedEditor as IWedEditorBoxSel).boxSelMgr;
	//Ce msg devrait provoquer le focus.
	if (wedMgr.docHolderAsync.isMsgFromUs(transac)) {
		//On est à l'origine de ce msg, on prend le Focus.
		//console.log("transac:::", transac);
		if (boxSelMgr.selInVirtual && (!transac.metas || !(transac.metas.undo || transac.metas.redo))) {
			//On reset le range par rapport au wedlet virtuel sel car msg peut être une insertion d'un container ancêtre.
			const anchor = boxSelMgr.activeWedlet.wedAnchor;
			boxSelMgr.range.setRange(anchor, anchor);
			boxSelMgr.redrawSelection(); //à la dévirtualisation, les boutons d'actions peuvent changer.
		}
		if (isXmlMsg(msg)) {
			if (msg instanceof XmlInsertMsg) {
				boxSelMgr.setSelection({start: msg.xa, end: XA.newBd(msg.xa).incrAtDepth(-1, JML.lengthJmlOrText(msg.jml) - 1).xa});
			} else {
				if (!boxSelMgr.focusAroundXAddr(msg.xa)) boxSelMgr.redrawSelection();
			}
			wedMgr.config.histoEditPointsMgr?.addEditEntry(new HistoEditPoint(msg.xa, wedMgr.docHolder.house), boxSelMgr.activeWedlet?.wedAnchor.length, wedMgr.config.histoEditHolder);
		} else if (msg instanceof XmlBatch && msg.selAfter) {
			if (msg.selAfter.end && typeof XA.last(msg.selAfter.end) === 'number') {
				boxSelMgr.setSelection({start: msg.selAfter.addr, end: XA.newBd(msg.selAfter.end).incrAtDepth(-1, -1).xa});
				wedMgr.config.histoEditPointsMgr?.addEditEntry(new HistoEditPoint(msg.selAfter.end, wedMgr.docHolder.house), boxSelMgr.activeWedlet?.wedAnchor.length, wedMgr.config.histoEditHolder);
			} else {
				if (!boxSelMgr.focusAroundXAddr(msg.selAfter.addr)) boxSelMgr.redrawSelection();
				wedMgr.config.histoEditPointsMgr?.addEditEntry(new HistoEditPoint(msg.selAfter.addr, wedMgr.docHolder.house), boxSelMgr.activeWedlet?.wedAnchor.length, wedMgr.config.histoEditHolder);
			}
		}
	} else {
		//todo marque éphémère d'une édition concurrente par un autre user ?
	}
}

function getCurrentSel(wedMgr: WedMgr): IXAddrRangeSel | undefined {
	const boxSelMgr = (wedMgr.wedEditor as IWedEditorBoxSel).boxSelMgr;
	if (!boxSelMgr.activeWedlet) return undefined;
	if (boxSelMgr.selInVirtual) {
		let w: IWedlet = boxSelMgr.activeWedlet;
		const virtualPath = WEDLET.buildVirtualPath(w);
		while (w.wedParent && w.wedParent.isVirtual()) w = w.wedParent;
		return {start: w.wedAnchor, startInText: false, virtualPath}; //point d'insertion
	}
	const sel = XA.cloneRange(boxSelMgr.range) as IXAddrRangeSel;
	sel.startInText = false;
	sel.endInText = false;
	return sel;
}

function onPointerDown(this: IWedEditorBoxSel, ev: MouseEvent) {
	if (ev.shiftKey) {
		const path = ev.composedPath();
		for (let i = 0; i < path.length; i++) {
			const elt = path[i];
			if (isEltBoxSelection(elt) && elt.wedlet.wedMgr === this.wedMgr && !(elt as IBoxStopSelection).stopBoxSelection) {
				if (this.boxSelMgr.activeWedlet !== elt.wedlet) {
					this.boxSelMgr.extendSelTo(elt.wedlet as IWedletBoxSelection);
					ev.preventDefault();
					ev.stopImmediatePropagation();
				}
				break;
			}
		}
	}
}

/**
 * Dans l'éditeur, pour les sous contexte wed indépendant : contenu diff, bloc exclus...
 * Indique que c'est un contexte isolé de sélection.
 */
export interface IBoxStopSelection {
	stopBoxSelection?: true
}

function onFocus(this: void, wedMgr: WedMgr, focusElt: Element) {
	const elt = DOMSH.findFlatParentEltOrSelf(focusElt, wedMgr.wedEditor.rootNode, (n: Node): n is Element => isEltBoxSelection(n) || (n as IBoxStopSelection).stopBoxSelection);
	//console.log("::onFocusBOX:",focusElt, elt);
	const editor = wedMgr.wedEditor as IWedEditorBoxSel;
	if (isEltBoxSelection(elt) && elt.wedlet.wedMgr === wedMgr) {
		if (elt.selMode !== 'caret') editor.boxSelMgr.htmlSel.removeAllRanges();
		editor.boxSelMgr.selectWedlet(elt.wedlet as IWedletBoxSelection);
		wedMgr.config.histoEditPointsMgr?.onEditPointFocus(elt.wedlet.wedAnchor, wedMgr.config.histoEditHolder);
	}
	//  else {
	// 	editor.boxSelMgr.clearSel();
	// }
}

function onBlur(this: void, wedMgr: WedMgr, ev: FocusEvent) {
	if (ev.relatedTarget instanceof Element) {
		//Si menu contextuel de cet éditeur, on garde la selection visible.
		//NOTE: usage de findFlatParentEltOrSelf(ev.relatedTarget) ici car ev.relatedTarget peut être le IS_Popupable lui-même si aucune action dans le menu n'est enabled.
		if (findElementWedlet((DOMSH.findFlatParentEltOrSelf(ev.relatedTarget, null, IS_Popupable) as IDomLogical)?.logicalParent)?.wedlet.wedMgr === wedMgr) return;
	}
	(wedMgr.wedEditor as IWedEditorBoxSel).boxSelMgr.hideSel();
}

function onClipboardEvent(wedMgr: WedMgr, ev: ClipboardEvent, focusElt: Element): void | true {
	if (IS_EltWedlet(focusElt) && isWedletBoxSelection(focusElt.wedlet)) {
		//Le focus est sur un élément de type 'Box'.
		const boxSelMgr = (wedMgr.wedEditor as IWedEditorBoxSel).boxSelMgr;
		if (!boxSelMgr) return;
		if (boxSelMgr.isSingleSel() && isEltBoxSelection(focusElt) && ("onClipboard" in focusElt)) {
			if (focusElt.onClipboard(ev)) return true;
		}
		const rg = boxSelMgr.range;
		switch (ev.type) {
		case 'copy':
			if (XA.isAttribute(rg.start) || !rg.isCollapsed) wedMgr.writeRangeToClipboard(rg, ev.clipboardData);
			return true;
		case 'cut':
			if (XA.isAttribute(rg.start) || !rg.isCollapsed) {
				wedMgr.writeRangeToClipboard(rg, ev.clipboardData);
				boxSelMgr.deleteContentSelection();
			}
			return true;
		case 'paste':
			doPaste(wedMgr, focusElt, boxSelMgr, ev.clipboardData);
			return true;
		}
	}
}

function onReadOnlyChange(wedMgr: WedMgr) {
	const boxSelMgr = (wedMgr.wedEditor as IWedEditorBoxSel).boxSelMgr;
	boxSelMgr.redrawSelection();
}

/** Tentative d'insertion autour ou de remplacement de elt par le presse-papier. */
async function doPaste(this: void, wedMgr: WedMgr, elt: IElementWedlet, boxSelMgr: BoxSelMgr, dataTrsf: DataTransfer) {
	const txStamp = wedMgr.txStamp;
	const menuPos = {posFrom: elt, fromY: 'middle', targetY: 'middle'} as ORelativePosition;

	function finalPaste(imp: ISkImporter, ctx: OSkPasteContext) {
		//execution de l'import.
		const batch = wedMgr.docHolder.newBatch();
		imp.doImport(ctx, batch);
		batch.doBatch();
	}

	//note: jamais appelé pour import en fils.
	function pasteWithPos(imp: ISkImporter, ctx: OSkPasteContext, pos: EPastePos | EPastePos) {
		if (!elt.isConnected) return;
		if (!pos || pos === EPastePos.replace || ctx.virtualPath) {
			if (!WEDLET.isWritableWedlet(elt.wedlet)) return;
			if (txStamp !== wedMgr.txStamp) ctx = newSiblingContext();
			finalPaste(imp, ctx);
		} else if (pos === EPastePos.before) {
			if (!WEDLET.isWritableWedlet(elt.wedlet.wedParent)) return;
			finalPaste(imp, {sel: {start: boxSelMgr.range.start}});
		} else if (pos === EPastePos.after) {
			if (!WEDLET.isWritableWedlet(elt.wedlet.wedParent)) return;
			finalPaste(imp, {sel: {start: XA.newBd(boxSelMgr.range.start).incrAtDepth(-1, 1).xa}});
		} else {
			const parentEditable = WEDLET.isWritableWedlet(elt.wedlet.wedParent);
			const actions: IAction<void>[] = [];
			if ((pos & EPastePos.before) > 0 && parentEditable) actions.push(new Action<void>('before').setLabel("Insérer avant").setExecute(() => {pasteWithPos(imp, ctx, EPastePos.before)}));
			if ((pos & EPastePos.replace) > 0 && WEDLET.isWritableWedlet(elt.wedlet)) actions.push(new Action<void>('replace').setLabel("Remplacer").setExecute(() => {pasteWithPos(imp, ctx, EPastePos.replace)}));
			if ((pos & EPastePos.after) > 0 && parentEditable) actions.push(new Action<void>('after').setLabel("Insérer après").setExecute(() => {pasteWithPos(imp, ctx, EPastePos.after)}));
			if (actions.length === 1) {
				actions[0].execute();
			} else if (actions.length > 0) {
				POPUP.showPopupActions({actions, restoreFocus: elt}, menuPos, elt);
			}
		}
	}

	async function pasteSelected(imp: ISkImporter, ctx: OSkPasteContext, asChild: boolean) {
		if (imp.needAsyncBuild && await imp.buildContentToImport(elt) === 'stop') return;
		if (!elt.isConnected) return;
		if (txStamp !== wedMgr.txStamp) {
			//des modif concurentes ont eu lieu (pendant l'async de tryPaste() et buildContentToImport())
			// => on reset le contexte pour forcer le recalcul.
			ctx = asChild ? newChildContext() : newSiblingContext();
		}
		if (!asChild && boxSelMgr.isSingleSel()) {
			pasteWithPos(imp, ctx, imp.pastePos);
		} else {
			finalPaste(imp, ctx);
		}
	}

	//Cas des box de type "part" qui absorbent la balise racine du modèle fils.
	//Recherche d'import en fils si : 1 seul sous-box wedlet non "forbidden" est displayed non focusable (ie box-static).
	//Correspond à une part d'une compo qui affiche son .model en masquant la racine.
	async function tryPasteAsChild(siblingImp?: ISkImporter[], siblingCtx?: OSkPasteContext, siblingMinMalue?: number) {
		let canAdd = true;
		let firstFound: boolean;
		(elt.wedlet as IParentWedlet).visitWedletChildren(0, Number.MAX_SAFE_INTEGER, (ch: IChildWedlet) => {
			if ((ch.model.nodeType === ENodeType.element || ch.model.nodeType === ENodeType.text) && isWedletSingleElt(ch) && !ch.element.classList.contains("forbidden")) {
				if (firstFound || ch.element.tabIndex >= 0) {
					//élément fils non unique ou fils sélectionnable
					canAdd = false;
					return 'stop';
				}
				//trouvé, on poursuit pour vérifier l'unicité.
				if (isDisplayedWedlet(ch)) firstFound = true;
			}
		});
		if (canAdd) {
			const childCtx = newChildContext();
			const doc = wedMgr.docHolder;
			if (cache.originalDom) {
				const childImports = await doc.house.schemaDom.tryPasteNodes(childCtx, cache.originalDom, cache);
				if (childImports) {
					const childMinMalus = childImports.reduce((acc, imp) => Math.min(acc, imp.malus), Infinity);
					if (siblingImp && siblingMinMalue <= childMinMalus) {
						selectImporters(siblingImp, siblingCtx, false);
					} else {
						selectImporters(childImports, childCtx, true);
					}
					return;
				}
			}
		}
		if (siblingImp) {
			selectImporters(siblingImp, siblingCtx, false);
		} else {
			POPUP.showNotifWarning("Aucun contenu du presse-papier n'a pu être importé.", elt);
		}
	}

	function selectImporters(imToSel: ISkImporter[], ctx: OSkPasteContext, asChild: boolean) {
		if (imToSel.length === 1 && imToSel[0].malus === 0) {
			//Une seule solution et import parfait.
			pasteSelected(imToSel[0], ctx, asChild);
		} else {
			const actions = [];
			imToSel.sort((a, b) => a.malus - b.malus);
			for (const imp of imToSel) actions.push(new Action().setLabel(imp.getLabel()).setExecute(() => {pasteSelected(imp, ctx, asChild)}));
			POPUP.showPopupActions({actions, restoreFocus: elt}, menuPos, wedMgr.wedEditor);
		}
	}

	function newSiblingContext(): OSkPasteContext {
		return {sel: boxSelMgr.range, virtualPath: WEDLET.buildVirtualPath(elt.wedlet.wedParent)};
	}

	function newChildContext(): OSkPasteContext {
		return {sel: {start: XA.append(elt.wedlet.wedAnchor, 0)}, virtualPath: WEDLET.buildVirtualPath(elt.wedlet)};
	}

	const cache: OSkImportDatas = {};
	const siblingCtx = newSiblingContext();
	const importers = await wedMgr.tryPaste(siblingCtx, cache, dataTrsf);
	if (!importers) {
		await tryPasteAsChild();
	} else {
		const minMalus = importers.reduce((acc, imp) => Math.min(acc, imp.malus), Infinity);
		if (minMalus > 0/* && !cache.deepFindDone*/) await tryPasteAsChild(importers, siblingCtx, minMalus);
		else selectImporters(importers, siblingCtx, false);
	}
}


function onKeyDown(this: IWedEditorBoxSel, ev: KeyboardEvent) {
	//console.log("onKeyDown:::::", ev);
	this.boxSelMgr.accelKeyMgr.handleKeyboardEvent(ev, this);
}

function ctxMenuActions(this: IEltBoxSelection): IContextMenuActions<IWedMgrPointer> {
	const wedMgr = this.wedlet.wedMgr;
	const editor = wedMgr.wedEditor as IWedEditorBoxSel;
	if (!editor.boxSelMgr) return null; //cas des renditions simples imbriquées dans un editeur.
	let actions = buildActions(this, wedMgr);
	const focusActionWidgets = editor.boxSelMgr.focusActionWidgets;
	for (let i = 0; i < focusActionWidgets.length; i++) {
		const actW = focusActionWidgets [i];
		if (actW.localName === 'box-btnadd') {
			const structs = (actW as IBoxBtns).structs;
			switch ((actW as IBoxBtns).structPos) {
			case "before":
				const subBefore = buildAddActions(this.wedlet, "before", structs);
				if (subBefore.length > 0) (actions || (actions = [])).push(new ActionMenu<IWedMgrPointer>('insBefore')
					.setLabel(this.wedlet.isVirtual() ? "Insérer autour ou remplacer..." : "Insérer avant...").setGroup("ins").setActions(subBefore));
				break;
			case "child":
				const subIn: IAction<IWedMgrPointer>[] = buildAddActions(this.wedlet, "child", structs);
				if (subIn.length > 0) {
					let last;
					if (!actions) actions = [];
					else last = actions[actions.length - 1];
					const newAct = new ActionMenu<IWedMgrPointer>('insInside').setLabel("Insérer dedans...").setGroup("ins").setActions(subIn);
					if (last?.getId() === 'insAfter') {
						actions[actions.length - 1] = newAct;
						actions.push(last);
					} else {
						actions.push(newAct);
					}
					const next = focusActionWidgets[i + 1];
					if (next?.localName === 'box-btnadd' && ((next as IBoxBtns).structPos) === 'child') {
						i++;
						//On fusionne les listes (children et attributs)
						const nextSubIn = buildAddActions(this.wedlet, "child", (next as IBoxBtns).structs);
						if (nextSubIn.length > 0) {
							subIn.push(new ActionSeparator());
							subIn.push(...nextSubIn);
						}
					}
				}
				break;
			case "after":
				if (DOMSH.isFlatAncestor(this, actW)) {
					const subAfter = buildAddActions(this.wedlet, "after", structs);
					if (subAfter.length > 0) (actions || (actions = [])).push(new ActionMenu<IWedMgrPointer>('insAfter')
						.setLabel("Insérer après...").setGroup("ins").setActions(subAfter));
				}
				break;
			}
		} else if (actW.localName === 'box-btnreplace') {
			const subReplace = buildReplaceActions((actW as IBoxBtns).structs, this.wedlet);
			if (subReplace.length > 0) (actions || (actions = [])).push(new ActionMenu<IWedMgrPointer>('replace')
				.setLabel("Remplacer...").setGroup("ins").setActions(subReplace));
		}
	}
	if (!actions || actions.length === 0) return null;
	actions = ACTION.injectSepByGroup(actions, this.groupOrder || wedMgr.reg.getPref(this.groupOrderPref || "groupOrder.wed.box", "ins insObj *"), this.wedlet);
	return {
		actions,
		actionContext: this.actionContext || new WedletActionCtx(this)
	}
}

function focusBar(this: IEltBoxSelection): BarActions<IWedMgrPointer> {
	if (this._focusBar === undefined) {
		const wedMgr = this.wedlet.wedMgr;
		const datas = wedMgr.getDatasForModel(this.wedlet.model) as IWedFocusBarPointer;
		if ("focusBar" in datas) {
			this._focusBar = datas.focusBar;
			if (!this._focusBar) return null;
			this._focusBar.actionContext.focusedElt = this;
			return this.focusBar;
		}
		let actions = buildActions(this, wedMgr);
		if (!actions || actions.length === 0) {
			this._focusBar = datas.focusBar = null;
		} else {
			actions = ACTION.injectSepByGroup(actions, this.groupOrder || wedMgr.reg.getPref(this.groupOrderPref || "groupOrder.wed.box", "ins insObj *"), this.wedlet);
			this._focusBar = datas.focusBar = new BarActions<IWedletActionCtx>().initialize({
				actions: actions,
				actionContext: this.actionContext || new WedletActionCtx()
			});
		}
	}
	if (this._focusBar === null) return null;
	this._focusBar.actionContext.focusedElt = this;
	return this._focusBar;
}

/** Actions pour le menu contextuel et la toolbar commune. */
function buildActions(this: void, elt: IEltBoxSelection, wedMgr: WedMgr): IAction<IWedMgrPointer>[] {
	if (wedMgr.config.noFocus) return null;
	let actions: IAction<IWedMgrPointer>[];
	if (elt.actionsLists) {
		actions = wedMgr.reg.mergeLists(...elt.actionsLists, "actions:wed:global");
	} else {
		actions = wedMgr.reg.getList("actions:wed:global");
	}
	return actions;
}

REG.reg.addSvcToList("actions:wed:global", "exclude", 1, 'wedBoxSelExclude', 10);
REG.reg.addSvcToList("actions:wed:global", "delete", 1, 'wedBoxSelDelete', 20);
